export type RewardCopyInput = {
  rewardZl: number;
  errorMessage?: string;
};

export type RewardCopy = {
  title: string;
  subtitle: string;
};

function isNetworkError(message: string): boolean {
  return /internet|offline|network|sie[ćc]|fetch/i.test(message);
}

/** Przyjazne copy bez surowych błędów i bez obietnicy nieistniejącej kolejki nagród. */
export function rewardCopy(input: RewardCopyInput): RewardCopy {
  if (input.rewardZl > 0) {
    return {
      title: 'Brawo!',
      subtitle: `+${input.rewardZl} zł`,
    };
  }

  if (input.errorMessage) {
    return {
      title: 'Super gra!',
      subtitle: isNetworkError(input.errorMessage)
        ? 'Nie udało się zapisać tej nagrody. Zagraj ponownie, gdy internet wróci 💛'
        : 'Nie udało się zapisać tej nagrody. Możesz zagrać jeszcze raz 💛',
    };
  }

  return {
    title: 'Super gra!',
    subtitle: 'Odpocznij chwilkę i spróbuj jeszcze raz ✨',
  };
}
